import i18n from 'i18next';
import type { VendorExportField } from './components';

// Use function because of async translation initialization
export const VENDOR_ADDRESS_SEARCH_EXPORT_FIELDS = (): VendorExportField[] => [
  {
    label: i18n.t('translation:default.fields.name'),
    name: 'name',
  },
  {
    label: i18n.t('translation:default.fields.address.label'),
    name: 'address',
  },
  {
    label: i18n.t('translation:default.fields.city.label'),
    name: 'city',
  },

  {
    label: i18n.t('translation:default.fields.state.label'),
    name: 'stateDesc',
  },
  {
    label: i18n.t('translation:default.fields.country.label'),
    name: 'countryName',
  },
  {
    label: i18n.t('translation:default.fields.zip'),
    name: 'zip',
  },
  {
    label: i18n.t('translation:default.fields.contactName.label'),
    name: 'contactName',
  },
  {
    label: i18n.t('translation:default.fields.phone'),
    name: 'businessPhone',
  },
  {
    label: i18n.t('translation:default.fields.phoneExt'),
    name: 'phoneExt',
  },
  {
    label: i18n.t('translation:default.fields.daysOfWeek'),
    name: 'daysOfWeek',
  },
  {
    label: i18n.t('translation:default.fields.hoursOfOperations'),
    name: 'hoursOfOperation',
  },
  {
    label: i18n.t('translation:default.fields.appointmentType.label'),
    name: 'appointmentType',
  },
  {
    label: i18n.t('translation:default.fields.email'),
    name: 'email',
  },
  {
    label: i18n.t('translation:default.fields.shipperReferenceNo'),
    name: 'shipperReferenceNo',
  },
];

export const ALL_LOCATIONS_OPTION = { value: '%', label: 'All' } as const;
